import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { CommonService } from '../../../services/common.service';
import { VendorService } from '../../../services/assets-management/vendor.service';
import { Vendor, ReqAddVendor, VendorContact, ReqAddVendorContact } from '../../../models/assets-management/vendor';
import { ActionEnum, StatusEnum, VendorContactTypeEnum } from '../../../models/common-enum';
import { SwalComponent } from '@sweetalert2/ngx-sweetalert2';
import * as _ from 'lodash';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { permission } from 'src/app/views/assets-management/_menu';

@Component({
  selector: 'app-vendor',
  templateUrl: './vendor.component.html',
  styleUrls: ['./vendor.component.scss']
})
export class VendorComponent implements OnInit {
  @ViewChild('emailInput', { static: false }) emailInput: ElementRef;
  @ViewChild('emailSubInput', { static: false }) emailSubInput: ElementRef;
  @ViewChild('addModal', { static: false }) public addModal: ModalDirective;
  @ViewChild('deleteModal', { static: false }) public deleteModal: ModalDirective;
  @ViewChild('addModalSub', { static: false }) public addModalSub: ModalDirective;
  @ViewChild('deleteModalSub', { static: false }) public deleteModalSub: ModalDirective;
  @ViewChild('swalSuccess', { static: false }) private swalSuccess: SwalComponent;
  @ViewChild('swalError', { static: false }) private swalError: SwalComponent;
  view: number = 1; //1= vendor,2
  statusEnum = StatusEnum;
  vendorContactTypeEnum = VendorContactTypeEnum;
  myDate = new Date();
  currentPage: any = 1;
  itemsPerPage: any = 10;
  totalItems: any = 0;
  totalSubItems: any = 0;
  data_list: Vendor[];
  data_sub_list: VendorContact[];
  status_list = [
    { id: StatusEnum.Active, name: "Active" },
    { id: StatusEnum.Inactive, name: "Inactive" }
  ];
  status: any;
  selectItem: any = {
    company_name: "",
    phone_number: "",
    address: "",
    contact_name: "",
    detail: "",
    email: "",
    hashtag: "",
    status: null
  };

  public allowCustom: boolean = false;
  res_message: any;
  status_modal: any;
  status_modal_sub: any;
  search_company_name: any;
  search_hashtag: any;

  vendor_contact_type: any;
  vendor_contact_type_list = [
    { id: VendorContactTypeEnum.Install, name: "ผู้ติดตั้ง" },
    { id: VendorContactTypeEnum.Ma, name: "ผู้ซ่อมบำรุง" },
    { id: VendorContactTypeEnum.InstallMa, name: "ผู้ติดตั้ง/ผู้ซ่อมบำรุง" }
  ];
  selectSubItem: any = {
    contact_id: null,
    contact_name: "",
    contact_tel: "",
    contact_email: "",
    contact_detail: "",
    contact_type: null,
    status: null,
    vendor_id: null
  };
  isAdd: boolean = false;
  isEdit: boolean = false;
  isAddContact: boolean = false;
  isEditContact: boolean = false;
  constructor(private commonService: CommonService, private vendorService: VendorService) {
    this.commonService.activityLog(ActionEnum.Get, `Assets Management ➡ Configuration ➡ Vendor`).subscribe(res => { }, error => { console.log(error); });
   }

  async ngOnInit() {
    this.is_loading = true;
    this.getVendor();
    this.isAdd = await this.commonService.getPermission(permission.configuration.vendor.add_id).toPromise();
    this.isEdit = await this.commonService.getPermission(permission.configuration.vendor.edit_id).toPromise();
    this.isAddContact = await this.commonService.getPermission(permission.configuration.vendor_contact.add_id).toPromise();
    this.isEditContact = await this.commonService.getPermission(permission.configuration.vendor_contact.edit_id).toPromise();
  }

  search() {
    this.currentPage = 1;
    this.getVendor();
  }
  handleValueStatus(value) {
    if (value) {
      //console.log(value);
      this.status = value;
    } else {
      this.status = null;
    }
  }
  is_loading: boolean = false;

  changeView(view_type?: number, vendor?: Vendor) {
    if (this.view != view_type) {
      this.view = view_type;
      if (view_type == 1) {
        this.getVendor();
        this.data_sub_list = [];
      } else {
        this.selectItem = vendor;
        this.status_modal = this.status_list.find(x => x.id == vendor.status);
        this.getVendorContact(this.selectItem.vendor_id);
      }
    }

  }
  getVendor() {
    this.data_list = [];
    this.vendorService.getVendor(this.currentPage, this.itemsPerPage, null, this.search_company_name, this.search_hashtag).subscribe(
      res => {
        if (res) {
          if (res.code == 1) {
            if (res.data) {
              this.data_list = res.data.data;
              this.totalItems = res.data.total_items;
            }else{
              this.totalItems = 0;
            }
          }else{
            this.totalItems = 0;
          }
        }else{
          this.totalItems = 0;
        }
        this.is_loading = false;
      },
      error => {
        this.is_loading = false;
        this.totalItems = 0;
      });
  }
  getVendorById(vendor_id) {
    this.data_list = [];
    this.vendorService.getVendorById(vendor_id).subscribe(
      res => {
        if (res) {
          if (res.code == 1) {
            if (res.data) {
              this.selectItem = res.data;
            }
          }
        }
        this.is_loading = false;
      },
      error => {
        this.is_loading = false;
      });
  }
  openAddModel() {
    this.selectItem = new Vendor();
    this.selectItem.company_name = "";
    this.selectItem.phone_number = "";
    this.selectItem.address = "";
    this.selectItem.detail = "";
    this.selectItem.email = "";
    this.selectItem.hashtag = "";
    this.selectItem.status = null;
    this.status_modal = null;
    this.addModal.show();
    this.status_modal = this.status_list.find(x => x.id == StatusEnum.Active);
    this.addModal.show();
  }
  openEditModel(item?: any) {
    this.selectItem = item;
    this.phoneValidate(item.phone_number);
    console.log(item);

    this.status_modal = this.status_list.find(x => x.id == item.status);
    this.addModal.show();
    this.valid_email = this.emailInput.nativeElement.validity.valid;
  }
  openDeleteModel(item?: any) {
    this.selectItem = item;
    this.deleteModal.show();
  }
  clearData() {
    if (this.view == 1) {
      this.selectItem = new ReqAddVendor();
    }
  }
  handleValueStatusModal(value) {
    if (value) {
      //console.log(value);
      this.status_modal = value;
    } else {
      this.status_modal = null;
    }
  }
  pageChanged(event: any): void {
    this.currentPage = event.page;
    this.getVendor();
  }
  addVendor() {
    this.is_loading = true;
    let req = new ReqAddVendor();
    req.company_name = this.selectItem.company_name;
    req.phone_number = this.selectItem.phone_number;
    req.address = this.selectItem.address;
    req.detail = this.selectItem.detail;
    req.email = this.selectItem.email;
    req.hashtag = this.selectItem.hashtag;
    req.status = this.status_modal.id;
    this.res_message = "";
    this.vendorService.addVendor(req).subscribe(
      res => {
        if (res) {
          if (res.code == 1) {
            const log_req_data = { url: `${this.vendorService.domain}/${this.vendorService.uri}`, request: req, response: res };
            this.commonService.activityLog(ActionEnum.Add, `Assets Management ➡ Configuration ➡ Vendor`, JSON.stringify(log_req_data)).subscribe(res => { }, error => { console.log(error); });
            this.res_message = `เพิ่ม Vendor สำเร็จ`;
            setTimeout(() => {
              this.swalSuccess.fire();
              this.is_loading = false;
              this.getVendor();

            }, 100);
            this.addModal.hide();
          } else {
            this.res_message = res.message;
            setTimeout(() => { this.swalError.fire(); this.is_loading = false; }, 100);
          }
        } else {
          setTimeout(() => { this.swalError.fire(); this.is_loading = false; }, 100);
        }
      },
      error => {
        console.log(error);
        if (error) {
          if (error.status == 403) {

          } else {
            const error_text = error.error.message || error.statusText;
            this.res_message = error_text;
            this.is_loading = false;
            setTimeout(() => { this.swalError.fire() }, 1000);
          }
        } else {
          setTimeout(() => { this.swalError.fire() }, 1000);
        }
        this.is_loading = false;
      });
  }
  editVendor() {
    this.is_loading = true;
    let req = new ReqAddVendor();
    req.company_name = this.selectItem.company_name;
    req.phone_number = this.selectItem.phone_number;
    req.address = this.selectItem.address;
    req.detail = this.selectItem.detail;
    req.email = this.selectItem.email;
    req.hashtag = this.selectItem.hashtag;
    req.status = this.status_modal.id;
    this.res_message = "";
    this.vendorService.editVendor(req, this.selectItem.vendor_id).subscribe(
      res => {
        if (res) {
          if (res.code == 1) {
            const log_req_data = { id: this.selectItem.vendor_id, request: req, response: res, url: `${this.vendorService.domain}/${this.vendorService.uri}/${this.selectItem.vendor_id}` };
            this.commonService.activityLog(ActionEnum.Edit, `Assets Management ➡ Configuration ➡ Vendor`, JSON.stringify(log_req_data)).subscribe(res => { }, error => { console.log(error); });
            this.res_message = `แก้ไข Vendor สำเร็จ`;
            setTimeout(() => {
              this.swalSuccess.fire();
              this.is_loading = false;
              this.getVendor();
              if (this.view == 2) {
                this.getVendorById(this.selectItem.vendor_id);
              }
            }, 100);
            this.addModal.hide();
          } else {
            this.res_message = res.message;
            setTimeout(() => { this.swalError.fire(); this.is_loading = false; }, 100);
          }
        } else {
          setTimeout(() => { this.swalError.fire(); this.is_loading = false; }, 100);
        }
      },
      error => {
        console.log(error);
        if (error) {
          if (error.status == 403) {

          } else {
            const error_text = error.error.message || error.statusText;
            this.res_message = error_text;
            this.is_loading = false;
            setTimeout(() => { this.swalError.fire() }, 1000);
          }
        } else {
          setTimeout(() => { this.swalError.fire() }, 1000);
        }
        this.is_loading = false;
      });
  }

  deleteVendor() {
    this.is_loading = true;
    let req = new ReqAddVendor();
    req.company_name = this.selectItem.company_name;
    req.phone_number = this.selectItem.phone_number;
    req.address = this.selectItem.address;
    req.detail = this.selectItem.detail;
    req.email = this.selectItem.email;
    req.hashtag = this.selectItem.hashtag;
    this.res_message = "";
    this.vendorService.deleteVendorEditStatus(req, this.selectItem.vendor_id).subscribe(
      res => {
        if (res) {
          if (res.code == 1) {
            this.commonService.activityLog(ActionEnum.Delete, `Assets Management ➡ Configuration ➡ Vendor`, JSON.stringify({ id: this.selectItem.vendor_id, url: `${this.vendorService.domain}/${this.vendorService.uri}/${this.selectItem.vendor_id}` })).subscribe(res => { }, error => { console.log(error); });
            this.res_message = `ลบ Vendor สำเร็จ`;
            setTimeout(() => {
              this.swalSuccess.fire();
              this.is_loading = false;
              this.getVendor();
            }, 100);
            this.deleteModal.hide();
          } else {
            this.res_message = res.message;
            setTimeout(() => { this.swalError.fire(); this.is_loading = false; }, 100);
          }
        } else {
          setTimeout(() => { this.swalError.fire(); this.is_loading = false; }, 100);
        }
      },
      error => {
        console.log(error);
        if (error) {
          if (error.status == 403) {

          } else {
            const error_text = error.error.message || error.statusText;
            this.res_message = error_text;
            this.is_loading = false;
            setTimeout(() => { this.swalError.fire() }, 1000);
          }
        } else {
          setTimeout(() => { this.swalError.fire() }, 1000);
        }
        this.is_loading = false;
      });
  }
  //phone
  valid_phone: boolean = null;
  phoneValidate(e) {
    if (e) {
      if (e.length == 10 || e.length == 9) {
        this.valid_phone = true;
      } else {
        this.valid_phone = false;
      }
    } else {
      this.valid_phone = null;
    }
  }
  valid_phone_sub: boolean = null;
  phoneSubValidate(e) {
    if (e) {
      if (e.length == 10 || e.length == 9) {
        this.valid_phone_sub = true;
      } else {
        this.valid_phone_sub = false;
      }
    } else {
      this.valid_phone = null;
    }
  }
  valid_email: boolean = null;
  emailOnValidatorChange(e) {
    this.valid_email = this.emailInput.nativeElement.validity.valid;
  }
  valid_email_sub: boolean = null;
  emailSubOnValidatorChange(e) {
    this.valid_email_sub = this.emailSubInput.nativeElement.validity.valid;
  }
  //------------------------------------------------------------//
  handleValueVendorContactType(value) {
    if (value) {
      //console.log(value);
      this.vendor_contact_type = value;
    } else {
      this.vendor_contact_type = null;
    }
  }
  handleValueStatusModalSub(value) {
    if (value) {
      //console.log(value);
      this.status_modal_sub = value;
    } else {
      this.status_modal_sub = null;
    }
  }

  getVendorContact(vendor_id) {
    this.data_sub_list = [];
    this.totalSubItems = 0;
    this.vendorService.getVendorContact(null, null, null, vendor_id).subscribe(
      res => {
        if (res) {
          if (res.code == 1) {
            if (res.data) {
              this.data_sub_list = res.data.data;
              this.totalSubItems = res.data.data.length;
            }
          }
        }
        this.is_loading = false;
      },
      error => {
        this.is_loading = false;
      });
  }
  openAddModelSub() {
    this.selectSubItem = new VendorContact();
    this.selectSubItem.contact_name = "";
    this.selectSubItem.contact_tel = "";
    this.selectSubItem.contact_email = null;
    this.selectSubItem.contact_type = null;
    this.selectSubItem.status = null;
    this.vendor_contact_type = null;
    this.vendor_contact_type = this.vendor_contact_type_list.find(x => x.id == VendorContactTypeEnum.Install);
    this.status_modal_sub = this.status_list.find(x => x.id == StatusEnum.Active);
    this.addModalSub.show();
  }
  openEditModelSub(item?: VendorContact) {
    this.selectSubItem = item;
    this.phoneSubValidate(item.contact_tel);
    this.status_modal_sub = this.status_list.find(x => x.id == item.status);
    this.vendor_contact_type = this.vendor_contact_type_list.find(x => x.id == item.contact_type);
    this.addModalSub.show();
    this.valid_email_sub = this.emailSubInput.nativeElement.validity.valid;
  }
  openDeleteModelSub(item?: any) {
    this.selectSubItem = item;
    this.deleteModalSub.show();
  }
  clearDataSub() {
    this.selectSubItem = new ReqAddVendorContact();
  }

  addVendorContact() {
    this.is_loading = true;
    let req = new ReqAddVendorContact();
    req.contact_name = this.selectSubItem.contact_name;
    req.contact_tel = this.selectSubItem.contact_tel;
    req.contact_email = this.selectSubItem.contact_email;
    req.contact_detail = this.selectSubItem.contact_detail;
    req.status = this.status_modal_sub.id;
    if (this.vendor_contact_type) {
      req.contact_type = this.vendor_contact_type.id;
    }
    this.res_message = "";
    this.vendorService.addVendorContact(req, this.selectItem.vendor_id).subscribe(
      res => {
        if (res) {
          if (res.code == 1) {
            const log_req_data = { url: `${this.vendorService.domain}/${this.vendorService.uri}/${this.selectItem.vendor_id}/${this.vendorService.uri_sub}`, request: req, response: res };
            this.commonService.activityLog(ActionEnum.Add, `Assets Management ➡ Configuration ➡ Vendor ➡ Vendor contact`, JSON.stringify(log_req_data)).subscribe(res => { }, error => { console.log(error); });
            this.res_message = `เพิ่ม Vendor contact สำเร็จ`;
            setTimeout(() => {
              this.swalSuccess.fire();
              this.is_loading = false;
              this.getVendorContact(this.selectItem.vendor_id);
            }, 100);
            this.addModalSub.hide();
          } else {
            this.res_message = res.message;
            setTimeout(() => { this.swalError.fire(); this.is_loading = false; }, 100);
          }
        } else {
          setTimeout(() => { this.swalError.fire(); this.is_loading = false; }, 100);
        }
      },
      error => {
        console.log(error);
        if (error) {
          if (error.status == 403) {

          } else {
            const error_text = error.error.message || error.statusText;
            this.res_message = error_text;
            this.is_loading = false;
            setTimeout(() => { this.swalError.fire() }, 1000);
          }
        } else {
          setTimeout(() => { this.swalError.fire() }, 1000);
        }
        this.is_loading = false;
      });
  }
  editVendorContact() {
    this.is_loading = true;
    let req = new ReqAddVendorContact();
    req.contact_name = this.selectSubItem.contact_name;
    req.contact_tel = this.selectSubItem.contact_tel;
    req.contact_email = this.selectSubItem.contact_email;
    req.contact_detail = this.selectSubItem.contact_detail;
    req.status = this.status_modal_sub.id;
    if (this.vendor_contact_type) {
      req.contact_type = this.vendor_contact_type.id;
    }
    this.res_message = "";
    this.vendorService.editVendorContact(req, this.selectSubItem.contact_id, this.selectItem.vendor_id).subscribe(
      res => {
        if (res) {
          if (res.code == 1) {
            const log_req_data = { vendor_id: this.selectItem.vendor_id, contact_id: this.selectSubItem.contact_id, url: `${this.vendorService.domain}/${this.vendorService.uri}/${this.selectItem.vendor_id}/${this.vendorService.uri_sub}/${this.selectSubItem.contact_id}`, request: req, response: res };
            this.commonService.activityLog(ActionEnum.Edit, `Assets Management ➡ Configuration ➡ Vendor ➡ Vendor contact`, JSON.stringify(log_req_data)).subscribe(res => { }, error => { console.log(error); });
            this.res_message = `แก้ไข Vendor contact สำเร็จ`;
            setTimeout(() => {
              this.swalSuccess.fire();
              this.is_loading = false;
              this.getVendorContact(this.selectItem.vendor_id);
            }, 100);
            this.addModalSub.hide();
          } else {
            this.res_message = res.message;
            setTimeout(() => { this.swalError.fire(); this.is_loading = false; }, 100);
          }
        } else {
          setTimeout(() => { this.swalError.fire(); this.is_loading = false; }, 100);
        }
      },
      error => {
        console.log(error);
        if (error) {
          if (error.status == 403) {

          } else {
            const error_text = error.error.message || error.statusText;
            this.res_message = error_text;
            this.is_loading = false;
            setTimeout(() => { this.swalError.fire() }, 1000);
          }
        } else {
          setTimeout(() => { this.swalError.fire() }, 1000);
        }
        this.is_loading = false;
      });
  }

  deleteVendorContact() {
    this.is_loading = true;
    let req = new ReqAddVendorContact();
    req.contact_name = this.selectSubItem.contact_name;
    req.contact_tel = this.selectSubItem.contact_tel;
    req.contact_email = this.selectSubItem.contact_email;
    req.contact_detail = this.selectSubItem.contact_detail;
    req.status = this.status_modal_sub.id;
    if (this.vendor_contact_type) {
      req.contact_type = this.vendor_contact_type.id;
    }
    this.res_message = "";
    this.vendorService.deleteVendorContactEditStatus(req, this.selectSubItem.contact_id, this.selectItem.vendor_id).subscribe(
      res => {
        if (res) {
          if (res.code == 1) {
            const log_req_data = { vendor_id: this.selectItem.vendor_id, contact_id: this.selectSubItem.contact_id, url: `${this.vendorService.domain}/${this.vendorService.uri}/${this.selectItem.vendor_id}/${this.vendorService.uri_sub}/${this.selectSubItem.contact_id}`, request: req, response: res };
            this.commonService.activityLog(ActionEnum.Delete, `Assets Management ➡ Configuration ➡ Vendor ➡ Vendor contact`, JSON.stringify(log_req_data)).subscribe(res => { }, error => { console.log(error); });
            this.res_message = `ลบ Vendor contact สำเร็จ`;
            setTimeout(() => {
              this.swalSuccess.fire();
              this.is_loading = false;
              this.getVendorContact(this.selectItem.vendor_id);
            }, 100);
            this.deleteModalSub.hide();
          } else {
            this.res_message = res.message;
            setTimeout(() => { this.swalError.fire(); this.is_loading = false; }, 100);
          }
        } else {
          setTimeout(() => { this.swalError.fire(); this.is_loading = false; }, 100);
        }
      },
      error => {
        console.log(error);
        if (error) {
          if (error.status == 403) {

          } else {
            const error_text = error.error.message || error.statusText;
            this.res_message = error_text;
            this.is_loading = false;
            setTimeout(() => { this.swalError.fire() }, 1000);
          }
        } else {
          setTimeout(() => { this.swalError.fire() }, 1000);
        }
        this.is_loading = false;
      });
  }

}
